import React, { Component, ReactNode } from 'react';
import './tooltip.css';
import Popup, { IPopupProps } from '../popup/Popup';

interface ITooltipProps extends IPopupProps {
	children: ReactNode;
}

export default class Tooltip extends Component<ITooltipProps> {
	render() {
		const { children, ...popupProps } = this.props;

		return (
			// @ts-ignore
			<Popup
				{...popupProps}
				containerClasses={['tooltip']}
				arrowClasses={['tooltip-arrow']}
			>
				{children}
			</Popup>
		);
	}
}
